import ApiService from '@/utils/ApiService'

export default {
  namespaced: true,
  state: {
    isLoading: false,
    updated: null,
    violations: {},
    retrieved: {
      idClient: '',
      agreementTags: [],
      agreementItems: [],
      agreementAdditionalItems: [],
      agreementPromotions: [],
      agreementsConsents: [],
      agreementDevices: [],
      agreementAddresses: [],
      agreementCustomFields: [],
      agreementVariants: [],
      paymentDaysInvoice: 7,
      monthlyInvoice: 0,
      vatInvoice: 1,
      electronicPayments: 1,
      advanceStatus: 0,
      idEXSBPaymentWay: null,
      paymentFrequency: 1
    }
  },
  getters: {
    isLoading: (state) => state.isLoading,
    updated: (state) => state.updated,
    violations: (state) => state.violations,
    retrieved: (state) => state.retrieved
  },
  mutations: {
    toggleLoading (state) {
      state.isLoading = !state.isLoading
    },
    setUpdated (state, updated) {
      state.updated = updated
    },
    reset (state) {
      state.updated = null
      state.isLoading = false
      state.violations = {}
      state.agreement = {}
    },
    setViolations (state, violations) {
      state.violations = violations
    },
    setRetrieved (state, payload) {
      Object.assign(state.retrieved, payload)
      // modifying data to fit form
      state.retrieved.agreementTags = state.retrieved.agreementTags.map(entry => {
        return { '@id': entry['@id'], value: entry.tag['@id'], text: entry.tag.tag }
      })
      state.retrieved.idClient = state.retrieved.idClient['@id']
      state.retrieved.idEXSBPaymentWay = state.retrieved.idEXSBPaymentWay ? state.retrieved.idEXSBPaymentWay['@id'] : null
      state.retrieved.agreementItems = state.retrieved.agreementItems.map(entry => {
        return {
          '@id': entry['@id'],
          item: entry.item ? entry.item['@id'] : null,
          priceGroup: entry.priceGroup ? entry.priceGroup['@id'] : null,
          priceUserData: entry.priceUserData,
          dateFrom: entry.dateFrom,
          dateTo: entry.dateTo,
          isCyclic: entry.isCyclic,
          canBeCyclic: !!entry.priceGroup || !!entry.item.isCyclic,
          hasPromotion: !!entry.promotion,
          hasPriceGroup: !!entry.priceGroup,
          promotion: entry.promotion ? entry.promotion['@id'] : null,
          alwaysSettleInFull: entry.alwaysSettleInFull
        }
      })
      state.retrieved.agreementAdditionalItems = state.retrieved.agreementAdditionalItems.map(entry => {
        return {
          '@id': entry['@id'],
          item: entry.item ? entry.item['@id'] : null,
          priceGroup: entry.priceGroup ? entry.priceGroup['@id'] : null,
          priceUserData: entry.priceUserData,
          dateFrom: entry.dateFrom,
          dateTo: entry.dateTo,
          isCyclic: entry.isCyclic,
          canBeCyclic: !!entry.priceGroup || !!entry.item.isCyclic,
          hasPromotion: !!entry.promotion,
          hasPriceGroup: !!entry.priceGroup,
          promotion: entry.promotion ? entry.promotion['@id'] : null,
          additionalDocumentTemplate: entry.additionalDocumentTemplate
        }
      })
      state.retrieved.agreementVariants = state.retrieved.agreementVariants.map(entry => {
        return {
          '@id': entry['@id'],
          title: entry.title,
          variantItems: entry.variantItems.map(variantItem => {
            return {
              '@id': variantItem['@id'],
              variant: entry['@id'],
              item: variantItem.item['@id'],
              dateFrom: variantItem.dateFrom,
              dateTo: variantItem.dateTo,
              alwaysSettleInFull: variantItem.alwaysSettleInFull,
              isCyclic: variantItem.isCyclic,
              promotion: variantItem.promotion
            }
          }),
          variantAdditionalItems: entry.variantAdditionalItems.map(variantAdditionalItem => {
            return {
              '@id': variantAdditionalItem['@id'],
              variant: entry['@id'],
              item: variantAdditionalItem.item['@id'],
              dateFrom: variantAdditionalItem.dateFrom,
              dateTo: variantAdditionalItem.dateTo,
              alwaysSettleInFull: variantAdditionalItem.alwaysSettleInFull,
              isCyclic: variantAdditionalItem.isCyclic,
              promotion: variantAdditionalItem.promotion
            }
          })
        }
      })
      state.retrieved.agreementPromotions = state.retrieved.agreementPromotions.map(entry => {
        return { '@id': entry['@id'], promotion: entry.promotion['@id'] }
      })
      state.retrieved.agreementDevices = state.retrieved.agreementDevices.map(entry => {
        return { '@id': entry['@id'], device: entry.device['@id'] }
      })
      state.retrieved.agreementAddresses = state.retrieved.agreementAddresses.map(entry => {
        return {
          '@id': entry['@id'],
          idUserDataAddress: entry.idUserDataAddress ? entry.idUserDataAddress['@id'] : null,
          addressType: entry.idUserDataAddress ? entry.idUserDataAddress.addressType : null,
          city: entry.idUserDataAddress ? entry.idUserDataAddress.city : null,
          postcode: entry.idUserDataAddress ? entry.idUserDataAddress.postcode : null,
          province: entry.idUserDataAddress ? entry.idUserDataAddress.province : null,
          street: entry.idUserDataAddress ? entry.idUserDataAddress.street : null
        }
      })
    }
  },
  actions: {
    async retrieve ({ commit }, id) {
      commit('toggleLoading')
      const response = await new ApiService(`${id}`).getResults()
      commit('setRetrieved', response)
      commit('toggleLoading')
    },
    async update ({ commit, state }) {
      let agreement = JSON.parse(JSON.stringify(state.retrieved))
      // modyfing data to fit expected server-side pattern
      agreement.agreementItems = agreement.agreementItems.map(entry => {
        return {
          '@id': entry['@id'],
          item: entry.item,
          priceGroup: entry.priceGroup,
          dateFrom: entry.dateFrom,
          dateTo: entry.dateTo,
          alwaysSettleInFull: entry.alwaysSettleInFull,
          isCyclic: entry.isCyclic,
          agreement: agreement['@id'],
          promotion: entry.promotion
        }
      })
      agreement.agreementAdditionalItems = agreement.agreementAdditionalItems.map(entry => {
        return {
          '@id': entry['@id'],
          item: entry.item,
          priceGroup: entry.priceGroup,
          dateFrom: entry.dateFrom,
          dateTo: entry.dateTo,
          alwaysSettleInFull: entry.alwaysSettleInFull,
          isCyclic: entry.isCyclic,
          agreement: agreement['@id'],
          promotion: entry.promotion,
          additionalDocumentTemplate: entry.additionalDocumentTemplate
        }
      })
      agreement.agreementVariants = agreement.agreementVariants.map(entry => {
        return {
          '@id': entry['@id'],
          title: entry.title,
          agreement: agreement['@id'],
          variantItems: entry.variantItems.map(variantItem => {
            return {
              '@id': variantItem['@id'],
              variant: entry['@id'],
              item: variantItem.item,
              dateFrom: variantItem.dateFrom,
              dateTo: variantItem.dateTo,
              alwaysSettleInFull: variantItem.alwaysSettleInFull,
              isCyclic: variantItem.isCyclic,
              promotion: variantItem.promotion
            }
          }),
          variantAdditionalItems: entry.variantAdditionalItems.map(variantAdditionalItem => {
            return {
              '@id': variantAdditionalItem['@id'],
              variant: entry['@id'],
              item: variantAdditionalItem.item,
              dateFrom: variantAdditionalItem.dateFrom,
              dateTo: variantAdditionalItem.dateTo,
              alwaysSettleInFull: variantAdditionalItem.alwaysSettleInFull,
              isCyclic: variantAdditionalItem.isCyclic,
              promotion: variantAdditionalItem.promotion
            }
          })
        }
      })
      agreement.agreementTags = agreement.agreementTags.map(entry => {
        return { '@id': entry['@id'], tag: entry.value, agreement: agreement['@id'] }
      })
      agreement.agreementsConsents = agreement.agreementsConsents.map(consent => {
        return { '@id': consent['@id'], consent: consent.consent['@id'], agree: consent.agree, agreement: agreement['@id'] }
      })
      agreement.agreementPromotions = agreement.agreementPromotions.map(entry => {
        return { '@id': entry['@id'], promotion: entry.promotion, agreement: agreement['@id'] }
      })
      agreement.agreementDevices = agreement.agreementDevices.map(entry => {
        return { '@id': entry['@id'], device: entry.device, agreement: agreement['@id'] }
      })
      const response = await new ApiService(agreement['@id']).put(agreement)
      if (response.status < 300) commit('setUpdated', await response.json())
      else commit('setViolations', response)
    },
    reset ({ commit }) {
      commit('reset')
    }
  }
}
